import { NavMessage } from "../messages/NavMessage";
import { ExtentContext } from "../../lib/context";
export class GroupContext extends ExtentContext {
    constructor(map, p_layer, name) {
        super(p_layer, map);
        this.p_layer = p_layer;
        this.name = name;
        this.has_measure = true;
        this.has_table = true;
        switch (name) {
            case 'nh':
                this.exit_contexts = ['singleton', 'nh', 'group', 'sale', 'land'];
                break;
            case 'sale':
                this.exit_contexts = ['singleton', 'sale', 'group', 'nh', 'land'];
                break;
            case 'land':
                this.exit_contexts = ['singleton', 'land', 'group', 'nh', 'sale'];
                break;
            default:
                this.exit_contexts = ['singleton', 'set', 'toolbar', 'nh', 'sale', 'land'];
        }
    }
    on_enter() { }
    on_exit() { }
    zoom() { }
    async click_handler(coord, alt) {
        await this.p_layer.add_feature_at_point(coord, alt);
        let id = this.p_layer.clicked;
        if (id)
            new NavMessage({ command: 'NAVIGATE', strap: id, clicked: true, alt: alt }).send();
    }
}
